import React from 'react';

export interface Props {
  selected: number;
  total: number;
  type?: 'circle' | 'bar';
}

export const ProgressIndicator = ({ selected, total, type = 'circle' }: Props): JSX.Element => {
  const percent = (selected / total) * 100;

  if (type === 'circle') {
    return (
      <div className='space-x-1 select-none'>
        {Array.from(Array(total).keys()).map(x => (
          <div
            key={x}
            className={`inline-block w-2.5 h-2.5 rounded-full ${x + 1 === selected ? 'bg-sapphire' : 'bg-neutral-200'}`}
          >
            &nbsp;
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className='w-full bg-emerald-100 rounded-full h-2.5'>
      <div className='bg-emerald h-2.5 rounded-full' style={{ 'width': `${percent}%` }} />
    </div>
  );
};
